module.exports = __webpack_public_path__ + "img/pop_49.0b44ff63.png";